import React, { Suspense, useEffect, useRef, useState } from 'react'
import FinalMolGrid from '../../components/FinalMolGrid/FinalMolGrid'
import DataLoader from '../../components/FinalMolGrid/ui/dataLoader/DataLoader'
import Buttons from '../../components/ui/button/Buttons'
import { BoardCommitteeDataListConfig } from './data/BoardCommitteeDataList.Data'
import { useAddEditBoardCommitteeMemberMutation, useDeleteBoardCommitteeMemberByIdMutation, useLazyGetBoardCommitteeMembersQuery } from '../../app/services/BoardCommitteeApproval/BoardCommitteeServiceApi'
import { paginationObj } from '../../utils/Constants'
import SwalAlert from '../../services/swalService/SwalService'
import ToastService from '../../services/toastService/ToastService'
import CenterModel from '../../components/ui/centerModel/CenterModel'
import AddMemberForm from './component/AddMemberForm';
import EditMemberForm from '../AdmissionCommitteeManagement/component/EditMemberForm'
import { encryptAESID } from '../../utils/Encryption'
import { getAuditContext } from '../../lib/authenticationLibrary'
const BoardCommitteeDataListData = () => {

  /* State */
  const BoardCommitteeListRef = useRef()
  const [dataSource, setDataSource] = useState();
  const { confirm, success, error } = SwalAlert();
  const audit = getAuditContext();
  const [pagination, setPagination] = useState({
    ...paginationObj,
  });
  const addMemberFormRef = useRef();
  const [openAddModalPopup, setOpenAddModalPopup] = useState(false); // Modal visibility state
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState();

  // API Calls
  const [getBoardCommitteeMembers,
    {
      isLoading: listLoading,
      isSuccess: listSuccess,
      data: listData
    },
  ] = useLazyGetBoardCommitteeMembersQuery();

  const [addEditBoardCommitteeMember,
    {
      isLoading: isAddEditMemberLoading,
      isSuccess: isAddEditMemberSuccess,
      data: addEditMemberResponse
    },
  ] = useAddEditBoardCommitteeMemberMutation();



  const [deleteBoardCommitteeMemberById,
    { isLoading: isDeleteMemberLoading, isSuccess: isDeleteMemberSuccess, data: deleteMemberResponse }
  ] = useDeleteBoardCommitteeMemberByIdMutation();

  useEffect(() => {
    if (!listLoading && listSuccess && listData) {
      setDataSource(listData.itemList);
      setPagination((prev) => ({ ...prev, totalCount: listData.totalCount }));
    }
  }, [listLoading, listSuccess, listData]);

  /* Handle Add/Edit Member Response */
  useEffect(() => {
    if (!isAddEditMemberLoading && isAddEditMemberSuccess && addEditMemberResponse) {
      if (!addEditMemberResponse.hasError) {
        success("Record has been added successfully.");
        setOpenAddModalPopup(false);
        getBoardCommitteeMembers(pagination);
      } else {
        error(addEditMemberResponse.errorMessage);
      }
    }
  }, [isAddEditMemberLoading, isAddEditMemberSuccess, addEditMemberResponse]);
  /* Handle Delete Member Response */
  useEffect(() => {
    if (!isDeleteMemberLoading && isDeleteMemberSuccess && deleteMemberResponse) {
      if (!deleteMemberResponse.hasError) {
        success("Record Deleted Successfully.");
        getBoardCommitteeMembers(pagination);
      } else {
        error(deleteMemberResponse.errorMessage);
      }
    }
  }, [isDeleteMemberLoading, isDeleteMemberSuccess, deleteMemberResponse]);

  useEffect(() => {
    getBoardCommitteeMembers(pagination);
  }, []);

  /* Pagination Handler */
  const handlePageChange = (page) => {
    const { pageNumber, pageSize } = page;
    getBoardCommitteeMembers({ ...pagination, pageSize, pageNo: pageNumber });
  };

  /* Add Member Modal Toggle */
  const handleAddMember = () => {
    setOpenAddModalPopup(!openAddModalPopup);
  };

  /* Edit Member Handler */
  // const handleEditClick = (data) => {
  //   const request = {
  //     AdminID: data.adminID,
  //     Name: data.name,
  //     Email: data.email
  //   };
  //   addEditBoardCommitteeMember(request);
  // };

  const handleEditClick = (data) => {
    setSelectedId(data.adminID)
    setIsEditModalOpen(!isEditModalOpen)
  }
  /* Delete Member Handler */
  const handleDeleteClick = (data) => {
    confirm('Delete?', 'Are you sure you want to Delete?', 'Delete', 'Cancel').then((confirmed) => {
      if (confirmed) {
        const request = {
          id: data.adminID,
          id2: audit.adminUserId,
          id3: audit.appId
        };
        deleteBoardCommitteeMemberById(request);
      }
    });
  };

  /* Save New Member Handler */
  const handleSaveMember = () => {
    const formData = addMemberFormRef.current?.getFormData();
    if (!formData) return;

    if (formData.password === formData.confirmPassword) {
      const request = {
        Name: formData.name,
        Email: formData.emailAddress,
        Password: formData.password,
        CreatedBy: audit.adminUserId,
        CreatedAppId: audit.appId
      };
      addEditBoardCommitteeMember(request);
    } else {
      ToastService.error('Password and Confirm Password Not Match');
    }
  };

  /* Grid Row Update Handler */
  const onRowDataUpdate = (updateData) => {
    handleEditClick(updateData);
  };

  /* Action Handlers */
  const actionHandler = {
    EDIT: handleEditClick,
    DELETE: handleDeleteClick
  };
  const editOpenModel = () => {
    setIsEditModalOpen(!isEditModalOpen);
    getBoardCommitteeMembers(pagination);
  }
  return (
    <div>
      <div className="membership-application">
        <div className="form-card">
          {/* Add Member Button */}
          <Suspense fallback={<DataLoader />}>
            <div className="d-flex justify-content-between ">
              <h5 className="align-self-end mb-1">Total Count: {listData?.totalCount || 0}</h5>
              <div className='mb-2'>
                <Buttons
                  onClick={handleAddMember}
                  buttonText="Add Member"
                  buttonTypeClassName="theme-btn btn mt-auto"
                />
              </div>
            </div>
          </Suspense>

          {/* Data Table */}
          <div className="table-100">
            <FinalMolGrid
              ref={BoardCommitteeListRef}
              configuration={BoardCommitteeDataListConfig}
              dataSource={dataSource}
              isLoading={listLoading}
              allowPagination
              pagination={pagination}
              onActionChange={actionHandler}
              onPageChange={handlePageChange}
              allowAddGridItem
              onRowDataUpdate={onRowDataUpdate}
            />
          </div>
          {isEditModalOpen &&
            <CenterModel
              modelTitle={'Edit member'}
              show={"test"}
              handleClose={editOpenModel}
              onUpload={editOpenModel}
            >
              <EditMemberForm selectedId={encryptAESID(selectedId)} />

            </CenterModel>
          }

          {/* Back Button */}
          <Buttons
            buttonText="Back"
            buttonTypeClassName="theme-btn btn mt-2"
          />
        </div>
      </div>

      {/* Add Member Modal */}
      {openAddModalPopup && (
        <CenterModel
          modelTitle="Add Member"
          show
          isLoading={isAddEditMemberLoading}
          isDisable={isAddEditMemberLoading}
          handleClose={handleAddMember}
        >
          <AddMemberForm
            ref={addMemberFormRef}
            handleSaveMember={handleSaveMember}
            isLoading={isAddEditMemberLoading}
          />
        </CenterModel>
      )}
    </div>
  )
}

export default BoardCommitteeDataListData 